<template>
  <b-form inline>
    <b-form-group v-for="(field, key) in fields"
                  v-if="!field.isAdvanced || isAdvanced"
                  :label="field.label"
                  :description="field.description"
                  :key="key"
    >
      <b-input
        v-if="fieldTypes.FIELD_TEXT === field.type"
        v-model="field.value"
      ></b-input>
      <b-select
        v-if="fieldTypes.FIELD_SELECT === field.type"
        v-model="field.value"
        :options="field.values"
      ></b-select>
      <b-form-checkbox
        v-if="fieldTypes.FIELD_CHECK_BOX === field.type"
        v-model="field.value"
      ></b-form-checkbox>
    </b-form-group>
    <div slot="footer">
      <b-button type="button" size="sm" variant="primary" v-on:click="search">
        <i class="fa fa-search" ></i> Search
      </b-button>
      <b-button
        type="button"
        size="sm"
        variant="primary"
        v-if="showAdvanced && hasAdvanced"
        v-on:click="advancedSearch"
      >
        <i class="fa fa-search" ></i> Advanced Search
      </b-button>
    </div>
  </b-form>
</template>

<script>
  import {SearchField} from "../../services/SearchField";
  import {PaginationMeta} from "../../models/PaginationMeta";

  export default {
    name: "search-from",
    data() {
      return {
        fieldTypes: SearchField.FIELD_TYPES,
        isAdvanced: false,
        hasAdvanced: false,
      }
    },
    props: {
      fields: {
        type: Array,
        default: new Array(new SearchField()),
      },
      pagination: {
        type: Object,
        default: new PaginationMeta(),
      },
      showAdvanced: {
        type: Boolean,
        default: true,
      },
    },
    methods: {
      search() {
        let params = {
          page: this.pagination.page,
          limit: this.pagination.limit,
        }
        this.fields.forEach(
          field => params[field.key] = field.value
        )
        this.$emit('click', params)
      },
      advancedSearch () {
        this.isAdvanced = this.isAdvanced ? false : true
      },
    },
    created() {
      this.fields.forEach(
        field => {
          if (field.isAdvanced === true) {
            this.hasAdvanced = true
          }
        }
      )
    }
  }
</script>

<style>
  button, select, input{
    margin-right: 5px;
  }
  form {
    padding-bottom: 10px;
    margin-right: 5px;
  }
</style>
